import MyTextField from "../TextField";
import { FormControl, Select } from "@mui/material";
import MyMenuList from "../MenuList";
import MyTextLabel from "../InputLabel";

const FormScreenTwo = ({ formData, formErrors, handleChange }) => {
  return (
    <>
      <FormControl
        variant="standard"
        fullWidth
        required
        error={!!formErrors.dobError}
      >
        <MyTextLabel shrink htmlFor={"dob"}>
          Proof of Youth
        </MyTextLabel>
        <MyTextField
          fullWidth
          id={"dob"}
          placeholder="21/04/1998"
          value={formData.dob}
          name="dob"
          type="date"
          onChange={handleChange}
        />
      </FormControl>
      <FormControl
        variant="standard"
        fullWidth
        required
        error={!!formErrors.localComError}
      >
        <MyTextLabel shrink htmlFor={"localCom"}>
          Select Your District
        </MyTextLabel>
        <Select
          fullWidth
          id={"localCom"}
          value={formData.localCom}
          onChange={handleChange}
          input={<MyTextField />}
          name="localCom"
          displayEmpty
          renderValue={(selected) => {
            if (selected.length === 0) {
              return "District1_Abeokuta";
            }
            return selected;
          }}
          sx={{
            "& .MuiSvgIcon-root": {
              color: "white",
            },
          }}
        >
          <MyMenuList value={""} disabled>
            District1_Abeokuta
          </MyMenuList>
          <MyMenuList value={"abeokuta"}>District1_Abeokuta</MyMenuList>
          <MyMenuList value={"abuja"}>District2_Abuja</MyMenuList>
          <MyMenuList value={"akure"}>District3_Akure</MyMenuList>
          <MyMenuList value={"benin"}>District3_Benin</MyMenuList>
          <MyMenuList value={"benue"}>District5_Benue</MyMenuList>
          <MyMenuList value={"calabar"}>District6_Calabar</MyMenuList>
          <MyMenuList value={"ibadan"}>District7_Ibadan</MyMenuList>
          <MyMenuList value={"ife"}>District8_Ife</MyMenuList>
          <MyMenuList value={"ilorin"}>District9_Ilorin</MyMenuList>
          <MyMenuList value={"jos"}>District10_Jos</MyMenuList>
          <MyMenuList value={"lagos"}>District11_Lagos</MyMenuList>
          <MyMenuList value={"portharcourt"}>
            District12_PortHarcourt
          </MyMenuList>
          <MyMenuList value={"Cooks"} name={"cooks"}>
            The Cooks
          </MyMenuList>
          <MyMenuList value={"enugu"}>Capitol_Enugu</MyMenuList>
        </Select>
      </FormControl>
      <FormControl
        variant="standard"
        fullWidth
        required
        error={!!formErrors.titleError}
      >
        <MyTextLabel shrink htmlFor={"title"}>
          Select Your Career In Your District
        </MyTextLabel>
        <Select
          fullWidth
          id={"title"}
          value={formData.title}
          onChange={handleChange}
          input={<MyTextField />}
          name="title"
          displayEmpty
          renderValue={(selected) => {
            if (selected.length === 0) {
              return "LCP";
            }
            return selected;
          }}
          sx={{
            "& .MuiSvgIcon-root": {
              color: "white",
            },
          }}
        >
          <MyMenuList value={""} disabled>
            LCP
          </MyMenuList>
          <MyMenuList value={"LCP"} name={"lcp"}>
            LCP
          </MyMenuList>
          <MyMenuList value={"LCVP"} name={"lcvp"}>
            LCVP
          </MyMenuList>
          <MyMenuList value={"Teamleader"} name={"teamleader"}>
            Team Leader
          </MyMenuList>
          <MyMenuList value={"Teammember"} name={"teammember"}>
            Team Member
          </MyMenuList>
          <MyMenuList value={"EST"} name={"est"}>
            EST
          </MyMenuList>
        </Select>
      </FormControl>
      <FormControl
        variant="standard"
        fullWidth
        required
        error={!!formErrors.isFirstConfError}
      >
        <MyTextLabel shrink htmlFor={"isFirstConf"}>
          Is This Your First Form Of AIESEC Training?
        </MyTextLabel>
        <Select
          fullWidth
          id={"isFirstConf"}
          value={formData.isFirstConf}
          onChange={handleChange}
          input={<MyTextField />}
          name="isFirstConf"
          displayEmpty
          renderValue={(selected) => {
            if (selected.length === 0) {
              return "Yes";
            }
            return selected;
          }}
          sx={{
            "& .MuiSvgIcon-root": {
              color: "white",
            },
          }}
        >
          <MyMenuList value={""} disabled>
            Yes
          </MyMenuList>
          <MyMenuList value={"Yes"} name={"yes"}>
            Yes
          </MyMenuList>
          <MyMenuList value={"no"} name={"no"}>
            No
          </MyMenuList>
        </Select>
      </FormControl>
    </>
  );
};

export default FormScreenTwo;
